import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { GetPageMetricsDto, FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

type Params = {
  startDateUtc?: string;
  endDateUtc?: string;
  page?: number;
  pageSize?: number;
};

const useGetPageMetricsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getPageMetricsRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.analytics.getPageMetrics>>): Promise<GetPageMetricsDto> {
    const accessToken = await getAccessToken();
    const [{ startDateUtc, endDateUtc, page, pageSize }] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/analytics/page-metrics`);
    if (startDateUtc !== undefined) url.searchParams.set("startDateUtc", startDateUtc);
    if (endDateUtc !== undefined) url.searchParams.set("endDateUtc", endDateUtc);
    if (page !== undefined) url.searchParams.set("page", page.toString());
    if (pageSize !== undefined) url.searchParams.set("pageSize", pageSize.toString());

    const response = await fetch(url.toString(), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getPageMetricsRequest };
};

const useGetPageMetrics = (params?: Params) => {
  const { getPageMetricsRequest } = useGetPageMetricsRequest();

  return useQuery({
    queryKey: queryKeys.analytics.getPageMetrics(params),
    queryFn: getPageMetricsRequest,
  });
};

export { useGetPageMetrics };
